import { Component, HostListener, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { NavigationEnd, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import Swal from 'sweetalert2';
import { ServicesService } from '../../shared/servicios/services.service';

@Component({
  selector: 'app-inicio-n',
  templateUrl: './inicio-n.component.html',
  styleUrls: ['./inicio-n.component.scss']
})
export class InicioNComponent implements OnInit {

  newsForm;

  newsVista: boolean = true;
  vistaRegistro: boolean = false;

  cookShow = true;
  expiredDate = new Date();
  message: any;

  constructor(public router: Router, public service: ServicesService, public cookieSvc: CookieService, public snackBar: MatSnackBar) {
    if (!this.cookieSvc.check(btoa('TriidyCookie'))) {
      const config = new MatSnackBarConfig();
      config.panelClass = ['snack-bar'];
      this.message = 'Utilizamos cookies propias y de terceros para obtener datos estadísticos de la navegación de nuestros usuarios y mejorar nuestros servicios. Si acepta o continúa navegando, consideramos que acepta su uso.';
      let snackBarRef = snackBar.open(this.message, 'Aceptar', config);
      snackBarRef.onAction().subscribe(() => {
        this.cookieSvc.set(btoa('TriidyCookie'), btoa('Acepto'), 30);
      });
    }
    this.newsForm = new FormGroup({
      nombre: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required])
    });
  }

  ngOnInit(): void {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0)
    });

    this.service.changeEmitted$.subscribe(
      text => {
        this.vistaRegistro = text;
      });
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(e) {
    if (window.pageYOffset > 50) {
      let element = document.getElementById('navbar');
      element.classList.add('sticky');
    } else {
      let element = document.getElementById('navbar');
      element.classList.remove('sticky');
    }
  }

  // NEWSFORM
  get nombre() { return this.newsForm.get('nombre'); }

  get email() { return this.newsForm.get('email'); }

  registroNws(): void {
    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Espere por favor...',
    });
    Swal.showLoading();

    const valueForm: any = { ...this.newsForm.value, };

    this.service.subscribeNewsletter(valueForm.nombre, valueForm.email).subscribe((data) => {
      Swal.close();
      const respuesta = data[0].response;
      Swal.fire({
        allowOutsideClick: false,
        icon: 'info',
        text: respuesta,
        confirmButtonText: 'Aceptar',
      }).then((result) => {
        if (result.isConfirmed) {
          this.newsVista = false;
        }
      });
    }, (err) => {
      const error = err;
      console.log(error);
      Swal.fire({
        allowOutsideClick: false,
        icon: 'info',
        text: 'Algo sucedio, intenta de nuevo',
        confirmButtonText: 'Aceptar',
      }).then((result) => {
        if (result.isConfirmed) {
          this.newsVista = false;
        }
      });
    });
  }

  listenChangesOfHeader(event) {
    this.vistaRegistro = true;
  }

  closeModal(event): void {
    this.vistaRegistro = false;
  }

}
